/** Each listener receives the current value once, then only changes to that value. */
export function createPhonePresenceSubscriptions(getCurrentValue: () => boolean) {
  const listeners = new Map<(onPage: boolean) => void, boolean>();

  return {
    subscribe(cb: (onPage: boolean) => void): () => void {
      const current = getCurrentValue();
      listeners.set(cb, current);
      cb(current);
      return () => {
        listeners.delete(cb);
      };
    },
    notify(): void {
      const current = getCurrentValue();
      for (const [cb, lastDelivered] of listeners) {
        if (lastDelivered === current) continue;
        listeners.set(cb, current);
        cb(current);
      }
    },
  };
}
